import { Component, OnInit, OnDestroy, ViewChild, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { PostTradeService } from '../../post-trade.service';
import { AccountGroupingDialogComponent } from '../../account-grouping/account-grouping-dialog/account-grouping-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { RbGridComponent } from '../../../shared-components/rb-grid/rb-grid.component';
import { AccountResult } from '../../../models/post-trade-models';

@Component({
  selector: 'app-account-grouping',
  templateUrl: './account-grouping.component.html',
  styleUrls: ['./account-grouping.component.scss'],
  standalone: false,
})
export class AccountGroupingComponent implements OnInit, OnDestroy {
  ptSvc = inject(PostTradeService);
  private activatedRoute = inject(ActivatedRoute);
  private dialog = inject(MatDialog);
  private snacky = inject(MatSnackBar);
  private route = inject(Router);

  @ViewChild(RbGridComponent) rbGrid: RbGridComponent;

  unsubscribe: Subject<any> = new Subject();
  groupId = '';
  gridConfig = {
    title: 'Account Grouping',
    gridName: 'AccountGroupingGrid',
    showGridFilters: true,
    showFilterManager: false,
    manualSearch: true,
    searchButtonText: 'Search Results',
    showBulkActions: false,
    downloadGridButton: false,
    gridActionColumn: true,
    previewActionText: 'View Group',
    showActionId: true,
    deleteRow: true,
    deleteRowText: 'DeleteGroup',
    rowSelector: 'GroupID',
    gridType: 'account-grouping',
    detailViewRoute: '/account-grouping/',
    showGridColumnFilters: true,
    getSetup: this.getGridSetup,
    getData: this.getGridData,
  };
  crumbConfig = [
    {
      label: 'Post Transaction',
      link: 'post-trade',
    },
    {
      label: 'Account Grouping',
      link: 'account-grouping',
    },
  ];

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        if (params.id) {
          this.groupId = params.id;
          this.crumbConfig.push({
            label: this.groupId,
            link: `account-grouping/${this.groupId}`,
          });
        } else {
          this.groupId = '';
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  getGridSetup() {
    return this.ptSvc.getAgGridSetup();
  }

  getGridData(reqData) {
    return this.ptSvc.getAccountGroupingGridData(reqData);
  }

  createNewGroup() {
    this.dialog.open(AccountGroupingDialogComponent, {
      data: {
        createGroup: true,
      },
      width: '80vw',
      maxWidth: '80vw',
      autoFocus: false,
    });
  }

  deleteGroup(ev) {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Delete Account Group?',
        content: 'Please confirm account group deletion.',
        confirm: 'Delete',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.ptSvc.deleteAccountGroup(ev.GroupID).subscribe({
          next: (response: AccountResult) => {
            if (response !== null && response.result === 'Success') {
              this.rbGrid.getGridData();
              this.snacky.open(`Account Group Removed`, 'Close', {
                duration: 4000,
              });
            }
          },
          error: err => {
            this.snacky.open(
              `Whoops something went wrong, please try again later!`,
              'Close',
              {
                duration: 3000,
              }
            );
            console.error(err);
          },
        });
      }
      dialogRef = null;
    });
  }
}
